import { Options } from 'prettier';

import { Tracking } from 'src/shared/types/basket-types';
import { Term } from 'src/shared/types/booking-types';

import { BasketUser } from '../types';

import { CreateBasketProductDto } from './CreateBasketProduct.dto';

export class CreateBasketDto {
    readonly id: string;

    readonly user: BasketUser;

    readonly products: CreateBasketProductDto[];

    readonly options: Options;

    readonly tracking: Tracking;

    readonly vendor: string;

    readonly payment_options_snapshot: Term[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawBasket: any) {
        this.id = rawBasket.id;
        this.user = rawBasket.user;
        this.products = [new CreateBasketProductDto(rawBasket.products[0])];
        this.options = rawBasket.options;
        this.tracking = rawBasket.tracking;
        this.vendor = rawBasket.vendor;
        this.payment_options_snapshot = rawBasket.payment_options_snapshot;
    }
}
